import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../constants/colors';
import { isForeignCityCar } from '../../utils/foreignCityCar';

/**
 * ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ: Ð¼Ð°ÑÐ¸Ð½Ð° ÑÑÐ¾Ð¸Ñ Ð² ÑÑÐ¶Ð¾Ð¼ Ð³Ð¾ÑÐ¾Ð´Ðµ.
 *
 * Ð¢Ð°ÐºÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑ Ðº Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÑÐµÐ· Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¿Ð¾Ð»Ð½Ð¾Ð¼Ñ VIN. ÐÐµÐ·
 * Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ñ Ð¾Ð½ ÑÐµÑÐ¸Ñ, ÑÑÐ¾ Ð¾Ð½Ð° ÐµÐ³Ð¾ Ð³Ð¾ÑÐ¾Ð´Ð°, Ð¸ ÑÐ´Ð¸Ð²Ð¸ÑÑÑ, Ð¿Ð¾ÑÐµÐ¼Ñ ÐµÑ Ð½ÐµÑ Ð²
 * ÑÐ¿Ð¸ÑÐºÐµ (24.10.2026, Ð¿ÑÐ¾ÑÑÐ±Ð° Ð¿ÐµÑÐµÐ½ÐµÑÑÐ¸ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² Ð¢Ð°ÑÐ°Ð·). ÐÐ¾ÑÐ¾Ð´ Ð¸ Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹
 * ÑÐµÐ½ÑÑ Ð¼ÐµÐ½ÑÑÑÑÑ ÑÑÑ Ð¶Ðµ, Ð² Ð¿Ð¾Ð»ÑÑ Ð½Ð¸Ð¶Ðµ.
 */
export default function ForeignCityNotice({ city }) {
  const userCities = useSelector((state) => state?.user?.cities);

  if (!isForeignCityCar(city?.id, userCities)) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
        border: `1px solid ${colors.orange}`,
        borderRadius: '8px',
        padding: '10px 14px',
        marginBottom: '16px',
        backgroundColor: '#FFF6E9',
      }}
    >
      <span
        style={{
          backgroundColor: colors.orange,
          color: colors.white,
          borderRadius: '10px',
          padding: '1px 8px',
          fontSize: '11px',
          whiteSpace: 'nowrap',
        }}
      >
        Ð´ÑÑÐ³Ð¾Ð¹ Ð³Ð¾ÑÐ¾Ð´
      </span>
      <span style={{ color: colors.blackPearl, fontSize: '14px' }}>
        ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ ÑÑÐ¾Ð¸Ñ Ð² Ð³Ð¾ÑÐ¾Ð´Ðµ {city?.title ?? 'Ð´ÑÑÐ³Ð¾Ð³Ð¾ Ð³Ð¾ÑÐ¾Ð´Ð°'} â Ð¾Ð½ Ð½Ðµ Ð¸Ð· Ð²Ð°ÑÐ¸Ñ Ð³Ð¾ÑÐ¾Ð´Ð¾Ð². Ð§ÑÐ¾Ð±Ñ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ñ Ð½Ð¸Ð¼,
        ÑÐ¼ÐµÐ½Ð¸ÑÐµ Ð³Ð¾ÑÐ¾Ð´ Ð¸ Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ Ð² Ð¿Ð¾Ð»ÑÑ Ð½Ð¸Ð¶Ðµ.
      </span>
    </div>
  );
}
